export default "__VITE_ASSET__Dv9dAA9A__"